import React, {PureComponent} from 'react'
import {Route, Switch} from 'react-router-dom'
import {inject} from 'mobx-react'

import Store from 'Store'
import BusinessUnitsForm from './container/BusinessUnitsForm'
import BusinessUnitsTable from './container/BusinessUnitsTable'

interface Props {
  store?: Store
}

@inject('store')
export default class Index extends PureComponent<Props, object> {

  constructor(props: Props) {
    super(props)
    props.store!.businessUnits.read()
  }

  render () {
    return (
      <Switch>
        <Route exact path="/businessunits" component={BusinessUnitsTable}/>
        <Route exact path="/businessunits/create" component={BusinessUnitsForm}/>

        <Route
          exact
          path="/businessunits/:id"
          component={props => <BusinessUnitsForm {...props} />}
        />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/BusinessUnits/index.tsx